import { createCrud } from '@lumahealthhq/ui-model';
var basePath = 'followupWorkflows';
var crud = createCrud(basePath);

/* Default queries */
export var useFollowupWorkflowCount = crud.makeCount();
export var useFollowupWorkflowById = crud.makeFindById();
export var useFollowupWorkflowByIds = crud.makeFindByIds();
export var useFollowupWorkflowMany = crud.makeFindMany();
export var useFollowupWorkflowOne = crud.makeFindOne();
export var useFollowupWorkflowPagination = crud.makePagination();

/* Default mutations */
export var useFollowupWorkflowCreateOne = crud.makeCreateOne();
export var useFollowupWorkflowUpdateOne = crud.makeUpdateOne();
export var useFollowupWorkflowRemoveById = crud.makeRemoveById();